import { Link, useParams } from "react-router-dom";
import { formatNewsDate, getNewsPost } from "../news/posts";
import { NotFoundPage } from "./NotFoundPage";

export function NewsPostPage() {
    const { date, title } = useParams();
    const post = getNewsPost(date, title);

    if (!post) {
        return <NotFoundPage />;
    }

    return (
        <>
            <section className="page-hero">
                <div className="content-wrapper py-4">
                    <h1 className="display-6 fw-semibold mb-0">{post.title}</h1>
                    <time className="news-card__date" dateTime={post.date}>
                        {formatNewsDate(post.date)}
                    </time>
                </div>
            </section>


            <div className="content-wrapper py-4">
                <p className="mb-4">
                    <Link className="text-decoration-none" to="/posts">
                        <i className="bi bi-arrow-left me-2" />Posts
                    </Link>
                </p>
                <article className="news-post card">
                    <div
                        className="card-body border-0"
                        dangerouslySetInnerHTML={{ __html: post.html }}
                    />
                </article>
            </div>
        </>
    );
}
